import apiStockist from '@/api/vo/stockist';

const defaultState = () => ({
	listStockist: [],
	stockistPagination: '',
});

const state = defaultState();

const getters = {};

const mutations = {
	setStockist(state, data) {
		state.listStockist = data.data;
		state.stockistPagination = data.pagination;
	},
};

const actions = {

	getStockist({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiStockist.getStockist(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setStockist', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setStockist', { data: [], pagination: {} });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};